import { push } from './shared';

export type UseTrackingSignupReturn = {
    trackSignupFormSuccess: VoidFunction;
};

export const useTrackingSignup = (): UseTrackingSignupReturn => {
    return {
        trackSignupFormSuccess(): void {
            push({ event: 'signup_form_success' });
        },
    };
};
